import React from 'react';
import { useTranslation } from 'react-i18next';
import Field from 'components/shared/Field';
import SVG from 'components/icons/SVG';
import styles from './styles.module.scss';

function SearchInput(props) {
  const { t } = useTranslation();
  return (
    <Field
      placeholder={t('common_search')}
      {...props}
      leadingInlineElements={
        <div className={styles.icon}>
          <SVG icon="search" fill="var(--color-grey-dark)" />
        </div>
      }
      fieldWrapperStyles={[styles.wrapper]}
    />
  );
}

// SearchInput.propTypes = {

// };

// SearchInput.defaultProps = {

// };

export default SearchInput;
